import templateStr from 'text!./templates/ho-policy-changes.html';
import _ from 'underscore';

export default ['endorsement.NumberOfChanges', '$filter', '$state', '$timeout', function (numberOfChanges, $filter, $state, $timeout) {
    return {
        restrict: 'EA',
        scope: {
            nextSteps: '=',
            policyChange: '=',
            canEditState: '=',
            transitionFn: '='
        },
        template: templateStr,
        link: function link($scope) {
            $scope.goToHoState = function (action) {
                var transitionPromise = void 0;
                if (angular.isDefined(action)) {
                    switch (action.entityType) {
                        case 'mortgagee':
                            transitionPromise = $scope.transitionFn('HOMortgagee');
                            break;
                        case 'scheduledProperty':
                            transitionPromise = $scope.transitionFn('HOValuables');
                            break;
                        default:
                            break;
                    }
                } else {
                    transitionPromise = $scope.transitionFn('HOCoverages');
                }

                if (transitionPromise) {
                    $scope.$root.$emit('endorsementShowHistory');
                }
            };

            $scope.getChangeTitle = function (change) {
                if (change.entityType === 'scheduledProperty') {
                    var value = change.entity ? ' (' + $filter('gwCurrency')({ amount: change.entity.exposureValue }) + ')' : '';
                    return '' + change.itemName + value;
                }
                return change.itemName;
            };

            $scope.editButtons = {
                'canEditCoverages': true,
                'canEditMortgagee': false,
                'canEditScheduledProperty': false
            };

            /**
             * Checks if there are any line coverages
             * and whether they are some displayable coverages
             * @returns {Boolean}
             */
            $scope.hasCoverageChanges = function () {
                var lineCoverages = _($scope.lineCoverageChanges).chain().values().flatten();
                var dwellingCoverages = _($scope.dwellingCoverageChanges).chain().values().flatten();
                return lineCoverages.some(coverageChangeIsDisplayable).value() && !lineCoverages.isEmpty().value() || dwellingCoverages.some(coverageChangeIsDisplayable).value() && !dwellingCoverages.isEmpty().value();
            };

            /**
             * If coverage change doesn't have an itemName,
             * it won't be possible to display it in a change box
             * @param {Object} change
             * @returns {Boolean}
             */
            function coverageChangeIsDisplayable(change) {
                return !!change.itemName;
            }

            function isLineCoverage(c) {
                return !c.parentId;
            }

            function updateChangesNumber(changeCollections) {
                $timeout(function () {
                    var lineChanges = _.first(changeCollections);
                    var restChanges = _.rest(changeCollections);
                    var lineChangesNum = _.isEmpty(lineChanges) ? 0 : 1;
                    var restChangesNum = restChanges.map(_.property('length')).reduce(function (memo, item) {
                        // sum the items
                        return memo + item;
                    }, 0);
                    numberOfChanges.set(lineChangesNum + restChangesNum);
                });
            }

            function _buildHistory(policyChange) {
                var lob = policyChange.lobData.homeowners;
                var coverages = lob.offerings[0].coverages;
                for (var i = 0; i < policyChange.history.length; i++) {
                    var historyItem = policyChange.history[i];
                    if (historyItem.entityType === 'mortgagee') {
                        historyItem.entity = _.findWhere(lob.coverables.additionalInterests, {
                            fixedId: historyItem.fixedId
                        });
                    } else if (historyItem.entityType === 'scheduledProperty') {
                        historyItem.entity = _.findWhere(coverages.schedules, {
                            fixedId: historyItem.fixedId
                        });
                    } else if (historyItem.entityType === 'coverage') {
                        historyItem.entity = _.findWhere(coverages.schedules, {
                            fixedId: historyItem.fixedId
                        });
                    }
                }
            }

            function _refreshCoverages() {
                $scope.hasChanges = true;
                $scope.lineCoverageChanges = {};
                $scope.dwellingCoverageChanges = {};
                $scope.scheduledPropertyChanges = [];
                $scope.mortgageeChanges = [];
                if ($scope.policyChange) {
                    _buildHistory($scope.policyChange);
                    _.each($scope.policyChange.history, function (h) {
                        switch (h.entityType) {
                            case 'coverage':
                                {
                                    if (coverageChangeIsDisplayable(h)) {
                                        if (isLineCoverage(h) && h.entity !== undefined) {
                                            var action = h.action;
                                            if (!$scope.lineCoverageChanges[action]) {
                                                $scope.lineCoverageChanges[action] = [h];
                                            } else {
                                                $scope.lineCoverageChanges[action].push(h);
                                            }
                                        } else {
                                            var _action = h.action;
                                            if (!$scope.dwellingCoverageChanges[_action]) {
                                                $scope.dwellingCoverageChanges[_action] = [h];
                                            }
                                            $scope.dwellingCoverageChanges[_action].push(h);
                                        }
                                    }
                                    break;
                                }
                            case 'mortgagee':
                                {
                                    $scope.mortgageeChanges.push(h);
                                    break;
                                }
                            case 'scheduledProperty':
                                {
                                    $scope.scheduledPropertyChanges.push(h);
                                    break;
                                }
                            default:
                                break;
                        }
                    });
                    populateCoverages();
                    // Transform     to array
                    $scope.dwellingCoverageChanges = _.values($scope.dwellingCoverageChanges);
                }
            }

            function populateCoverages() {
                $scope.coveragesChanged = angular.isDefined($scope.dwellingCoverageChanges.changed) ? _.uniq($scope.dwellingCoverageChanges.changed).concat($scope.lineCoverageChanges.changed) : $scope.lineCoverageChanges.changed;
                $scope.coveragesAdded = angular.isDefined($scope.dwellingCoverageChanges.added) ? _.uniq($scope.dwellingCoverageChanges.added).concat($scope.lineCoverageChanges.added) : $scope.lineCoverageChanges.added;
                $scope.coveragesRemoved = angular.isDefined($scope.dwellingCoverageChanges.removed) ? _.uniq($scope.dwellingCoverageChanges.removed).concat($scope.lineCoverageChanges.removed) : $scope.lineCoverageChanges.removed;
            }

            _refreshCoverages();

            $scope.$watchCollection('policyChange.history', function () {
                _refreshCoverages();
            });

            // update number of changes when there are
            // changes in the group below.
            var changesGroup = ['lineCoverageChanges', 'dwellingCoverageChanges', 'mortgageeChanges', 'scheduledPropertyChanges'];
            updateChangesNumber(changesGroup.map(_.propertyOf($scope)));
            $scope.$watchGroup(changesGroup, updateChangesNumber);

            $scope.$watchGroup(['nextSteps.mortgagee', 'nextSteps.valuables'], function (val) {
                if (angular.isDefined(val)) {
                    $scope.editButtons.canEditMortgagee = val[0] || false;
                    $scope.editButtons.canEditScheduledProperty = val[1] || false;
                }
            });
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/endorsement/ho/directives/HOPolicyChanges.js
// module id = 1460
// module chunks = 0